import type { ApplicantScopedKeyArguments } from "./callScriptShared.types";

export type CallScriptResidenceKeyArguments = ApplicantScopedKeyArguments;

/**
 * Query keys for the residence ("Customer Verification") Call Script.
 *
 * Deliberately a separate namespace from `callScriptKeys` — in CAPS2 the
 * residence and employment scripts are two unrelated screens backed by
 * different question sets (CVDQ/CVSSQ vs. the income-slot types), so
 * invalidating one must never refetch the other.
 */
export const callScriptResidenceKeys = {
  all: ["callScriptResidence"] as const,
  history: (arguments_: CallScriptResidenceKeyArguments) =>
    [...callScriptResidenceKeys.all, "history", arguments_] as const,
};
